import { Fragment } from 'react'

import { Trans, useTranslation } from 'next-i18next'

import ActivityProgressCard from '~/statistics-v2/components/ActivityProgressCard'
import { PracticeActivityStructure } from '~/statistics-v2/types/statistics.types'

export default function ActivityPerformanceViewer({
  activities,
  subTopicPath,
}: {
  activities: Array<{
    name: string
    activitySets: Array<{ name: string; details: PracticeActivityStructure; url?: string }>
  }>
  subTopicPath: string
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  return (
    <div className="flex flex-col">
      <h2 className="text-white text-xl lg:text-4xl font-black py-4">{t('activitySetPerformance')}</h2>

      <div className="flex flex-col gap-8">
        {activities.map((activity, index) => (
          <div className="flex flex-col gap-8" key={activity.name}>
            <div className="flex flex-col gap-6">
              <div className="flex items-center gap-3">
                <div className="flex bg-white/20 text-white text-xxs lg:text-sm font-bold px-1 py-1 rounded border border-white/20 whitespace-nowrap">
                  {Trans({
                    t,
                    i18nKey: 'level',
                    children: t('level'),
                    values: { levelNumber: index + 1 },
                  })}
                </div>
                <div className="flex text-gray-lavender text-xs lg:text-sm leading-5 w-full">{activity.name}</div>
                <div className="flex h-0.5 w-full lg:max-w-full max-w-16 bg-green-lime" />
              </div>

              <div className="flex flex-col gap-4">
                {Object.entries(activity.activitySets).map(([activitySetId, activitySet], i) => (
                  <Fragment key={activitySetId}>
                    <h1 className="text-white text-sm font-bold w-full">{`${t('practiceActivities')} ${i + 1}`}</h1>
                    <div className="grid place-items-center lg:place-items-start grid-cols-1 lg:grid-cols-3 gap-6">
                      {Object.entries(activitySet.details.difficulties).map(([difficultyId, difficultyData], j) => (
                        <ActivityProgressCard
                          key={difficultyId}
                          props={{
                            ...difficultyData,
                            index: j,
                          }}
                          subTopicPath={`${subTopicPath}/${activitySet.url}`}
                        />
                      ))}
                    </div>
                  </Fragment>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
